/**
 * Polyfills to load before the script
 */
if (!globalThis.crypto) {
  // Versions of Node < 20 do not have crypto attached to global by default
  // and this is required by @contensis/html-canvas package
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const crypto = require('node:crypto');
  globalThis.crypto = crypto.webcrypto;
}

/**
 * Versions of Node < 20 do not have crypto attached to global by default
 * and this is used by @contensis/html-canvas package
 */
export const polyfillNodeCrypto = async () => {
  if (!globalThis.crypto) {
    // Node18 docs: Use require('node:crypto').webcrypto to access this experimental module.
    // https://nodejs.org/docs/latest-v18.x/api/webcrypto.html
    const crypto = await import('node:crypto');
    globalThis.crypto = (crypto as any).webcrypto as Crypto;
  }
};

/**
 * Cannot statically import @contensis/html-canvas with Node < 20 as we require
 * a patch for the crypto lib onto the global object
 */
export const asyncImportHtmlParser = async () => {
  await polyfillNodeCrypto();
  const p = await import('@contensis/html-canvas');
  return p as (typeof p)['default'];
};

export const patchForDeterministicIds = (prefix = '') => {
  // patch the `randomUUID` function inside crypto lib
  global.crypto.randomUUID = (() => {
    let counter = 0;
    return (() => {
      // Create a composite key for each parsed content block
      const key = `${prefix}-${++counter}`;
      return key;
    }) as typeof global.crypto.randomUUID;
  })();
};


/** enterprise-fetch v2 uses the native node fetch if available which
 *  does not work with Management API file uploads correctly,
 * so we force it to fallback to use the older `node-fetch` implementation
 * which the Management API is deisgned to work with.
 * Native fetch shows this when uploading an asset: 

content-length: 17

[object FormData]
 * where node-fetch show this
Content-Length: 53427

----------------------------220769149404052112875897
Content-Disposition: form-data; name="file"; filename="default-meta1.jpg"
Content-Type: image/jpeg

...binary data...
*/
export const patchFetchForFileUploads = () => {
  // Set a global flag that enterprise-fetch v2 checks to force fallback
  (globalThis as any).fallbackFetch = true;
};
